import CryptoJS from 'crypto-js';

// 计算文件的 MD5 哈希值
export const calculateFileHash = (file) => {
  return new Promise((resolve, reject) => {
    const chunkSize = 10 * 1024 * 1024; // 每次读取 10MB
    const totalChunks = Math.ceil(file.size / chunkSize);
    const reader = new FileReader();
    let currentChunk = 0;
    let hash = CryptoJS.algo.MD5.create(); // 创建 MD5 哈希实例

    // 处理读取的文件分块
    reader.onload = function (event) {
      const wordArray = CryptoJS.lib.WordArray.create(event.target.result);
      hash.update(wordArray); // 更新哈希值
      currentChunk++;

      if (currentChunk < totalChunks) {
        loadNextChunk();
      } else {
        // 所有分块读取完成，返回最终哈希值
        const finalHash = hash.finalize().toString(CryptoJS.enc.Base64);
        resolve(finalHash);
      }
    };

    // 读取文件分块失败
    reader.onerror = function (error) {
      reject(error);
    };

    // 加载下一块文件
    function loadNextChunk() {
      const start = currentChunk * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const blob = file.slice(start, end);
      reader.readAsArrayBuffer(blob);
    }

    // 开始读取第一个分块
    loadNextChunk();
  });
};



// WEBPACK FOOTER //
// ./src/utils/file_hash.js